"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationStylingService = void 0;
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var OrganizationStylingService = /** @class */ (function () {
    function OrganizationStylingService() {
        var _this = this;
        this.defaultReject = function (message) { return Promise.reject(new sdk_backend_spi_1.NotSupported(message)); };
        this.defaultRejectTheme = function () {
            return _this.defaultReject("Backend does not support theming on organization level");
        };
        this.defaultRejectColorPalette = function () {
            return _this.defaultReject("Backend does not support color palette on organization level");
        };
        this.getThemes = function () { return _this.defaultRejectTheme(); };
        this.getActiveTheme = function () { return _this.defaultRejectTheme(); };
        this.setActiveTheme = function () { return _this.defaultRejectTheme(); };
        this.clearActiveTheme = function () { return _this.defaultRejectTheme(); };
        this.createTheme = function (_theme) { return _this.defaultRejectTheme(); };
        /**
         * Update existing theme on organization level.
         *
         * @returns promise
         */
        this.updateTheme = function (_theme) { return _this.defaultRejectTheme(); };
        /**
         * Delete theme on organization level.
         *
         * @returns promise
         */
        this.deleteTheme = function (_themeRef) { return _this.defaultRejectTheme(); };
        this.getColorPalettes = function () { return _this.defaultRejectColorPalette(); };
        this.getActiveColorPalette = function () { return _this.defaultRejectColorPalette(); };
        this.setActiveColorPalette = function () { return _this.defaultRejectColorPalette(); };
        this.clearActiveColorPalette = function () { return _this.defaultRejectColorPalette(); };
        this.createColorPalette = function (_colorPalette) { return _this.defaultRejectColorPalette(); };
        this.updateColorPalette = function (_colorPalette) { return _this.defaultRejectColorPalette(); };
        this.deleteColorPalette = function (_colorPaletteRef) { return _this.defaultRejectColorPalette(); };
    }
    return OrganizationStylingService;
}());
exports.OrganizationStylingService = OrganizationStylingService;
//# sourceMappingURL=styling.js.map